import connectService from './ConnectService';
import { ID_SERVICE_PATH } from '../consts';

const { useGet, usePost } = connectService(ID_SERVICE_PATH);

export function useInviteTokenDetails(token) {
	return useGet(`/invite/${token}`);
}

export function useHasSession() {
	const [{ status, ...rest }, getSession] = useGet('/checkSession');
	return [{ hasSession: status === 204, ...rest }, getSession];
}

export function useCreateIdentity() {
	const [res, createIdentity] = usePost('/identities');
	return [
		res,
		({ fullname, email, password, inviteToken }) => {
			createIdentity({
				json: {
					fullname,
					email,
					password,
					inviteToken
				}
			});
		}
	];
}

export function useCreateMembership(orgId, accountId) {
	const [res, createMember] = usePost(`/memberships/organization/${orgId}/account/${accountId}`);
	return [
		res,
		({ token }) => {
			createMember({
				json: {
					token
				}
			});
		}
	];
}

export function useCreateIdentityAndMembership(orgId) {
	const [res, createIdentityAndMembership] = usePost(`/memberships/organization/${orgId}`);

	return [
		res,
		({ fullname, email, password, inviteToken }) => {
			createIdentityAndMembership({
				json: {
					fullname,
					email,
					password,
					inviteToken
				}
			});
		}
	];
}

export function useInitiatePasswordReset() {
	return usePost('/identities/forgotPassword');
}

export function usePasswordResetTokenInfo(token, email) {
	const [res, getInfo] = useGet(`/identities/resetPassword/${encodeURIComponent(token)}`);

	return [
		res,
		() =>
			getInfo({
				searchParams: {
					email
				}
			})
	];
}

export function useUpdatePassword() {
	return usePost('/identities/resetPassword');
}

export function useSignIn() {
	const [res, signIn] = usePost('/login');
	return [
		res,
		(Email, Password, returnUrl) => {
			signIn({ json: { Email, Password, ReturnUrl: returnUrl ? decodeURIComponent(returnUrl) : null } });
		}
	];
}
